var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn && _vm.accountUserDetail
    ? _c("div", { staticClass: "user-avatar" }, [
        _c(
          "div",
          { staticClass: "user-avatar__image" },
          [
            _vm.accountUserDetail.image
              ? _c("img", {
                  staticClass: "user-avatar__image-element",
                  attrs: { src: _vm.accountUserDetail.image, loading: "eager" }
                })
              : _vm.accountUserDetail.avatar
              ? _c("img", {
                  staticClass: "user-avatar__image-element",
                  attrs: {
                    src: _vm.themeImagePath(
                      _vm.accountUserDetail.avatar + ".png"
                    ),
                    loading: "eager"
                  }
                })
              : _c("InitialsAvatar", {
                  staticClass: "user-avatar__image-element",
                  attrs: { initials: _vm.initials }
                })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { ref: "levelMeter", staticClass: "user-avatar__meter" })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }